import React from 'react';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { hideDialogAction, showDialogAction } from 'components/redux-dialog/actions';
import { Form, reduxForm, getFormValues, reset } from 'redux-form';
import { FORM_NAME, STEP, STEPS, WEBCAM_RECORDING_DIALOG, STREAM } from './fields';
import { useDispatch, useSelector } from 'react-redux';
import { WIZZARD as WEBCAM_WIZZARD } from './webcam-recording/webcam-wizzard';
import { WIZZARD as SCREEN_WIZZARD } from './screen-recording/screen-wizzard';

import { openCancelRecordingDialog } from './cancel-recording-dialog';
import { dialogSelector } from 'components/redux-dialog/selectors';

const DialogContent = ({ handleClose }) => {
  const formData = useSelector(getFormValues(FORM_NAME));
  const type = useSelector(dialogSelector)(WEBCAM_RECORDING_DIALOG)?.data.type;
  const WIZZARD = type === 'screen' ? SCREEN_WIZZARD : WEBCAM_WIZZARD;
  const { Title, Body, Footer } = WIZZARD?.[formData?.[STEP]];

  return (
    <>
      <DialogTitle handleClose={handleClose}>
        <Title />
      </DialogTitle>
      <DialogBody>
        <Body />
      </DialogBody>
      <DialogFooter>
        <Footer />
      </DialogFooter>
    </>
  );
};

export const openWebcamRecordingDialog = (dispatch, payload) => {
  dispatch(showDialogAction(WEBCAM_RECORDING_DIALOG, payload));
};

export const closeWebcamRecordingDialog = (dispatch, stream) => {
  document.body.style.overflowY = '';
  dispatch(hideDialogAction(WEBCAM_RECORDING_DIALOG));
  window.VideoCaptureAPI.stopMediaTracks(stream);
  dispatch(reset(FORM_NAME));
};

export const WebcamRecordingDialog = () => {
  const dispatch = useDispatch();
  const formData = useSelector(getFormValues(FORM_NAME));
  const type = useSelector(dialogSelector)(WEBCAM_RECORDING_DIALOG)?.data?.type;

  const closeDialogHandler = () => {
    if (formData?.[STEP] === STEPS.CONFIGURATION) {
      closeWebcamRecordingDialog(dispatch, formData?.[STREAM]);
    } else {
      dispatch(openCancelRecordingDialog());
    }
  };

  return (
    <div className={`ct-webcam-recording-dialog ${type ? ` ct-${type}-recording` : ''}`}>
      <DialogDecorated
        data-e2e="webcam-recording-dialog"
        style={{ width: '670px', maxWidth: '670px' }}
        dialogName={WEBCAM_RECORDING_DIALOG}
      >
        <Form onSubmit={() => {}}>{formData ? <DialogContent handleClose={closeDialogHandler} /> : null}</Form>
      </DialogDecorated>
    </div>
  );
};

export const WebcamRecordingDialogDecorated = reduxForm({
  initialValues: {
    [STEP]: STEPS.CONFIGURATION,
    agreedToRecord: false,
  },
  form: FORM_NAME,
  destroyOnUnmount: false,
})(WebcamRecordingDialog);
